/* tslint:disable */
/* eslint-disable */
export enum PostSaleOrderCreationConflictType {
  LotIsNotInPostSale = 'lot_is_not_in_post_sale',
  CreditLimitExceeded = 'credit_limit_exceeded',
  AddressIsIncomplete = 'address_is_incomplete',
  BidderTermsAndConditionsNotAccepted = 'bidder_terms_and_conditions_not_accepted',
  NotAllowed = 'not_allowed'
}
